const getDefaultState = () =>{
  return {
    reports: [],
    packages: [],
    isChange: false
  }
}

const state = getDefaultState();

const getters = {
  getReports: (state) => {
    return state.reports
  },
  getCharacters: (state) => (package_id)=> {
    let packageObj = state.packages.find((packageObj)=> packageObj.config.id == package_id)
    let trait_ids = packageObj.characters.map(character => character.trait_ids)
    return trait_ids.flat()
  }
};

const mutations = {
  updateReports: (state, term) => {
    state.reports = term
  },
  updateReport: (state, term) => {
    let reportInd = state.reports.findIndex(item => item.id == term.id)
    state.reports[reportInd].attributes = term.attributes
  },
  addNew: (state, term) => {
    state.formStatus[term.index].addNew = true
  },
  updateTrait: (state, term) => {
    let packageObj = state.packages.find((packageObj)=> packageObj.config.id == term.package_id)
    let characterObj = packageObj.characters.find((character)=> character.id == term.character_id)
    characterObj.trait_ids.push(characterObj.tempTrait)
    characterObj.tempTrait = {id: '', value: ''}
    state.isChange = true
  },
  removeTrait: (state, term) => {
    let packageObj = state.packages.find((packageObj)=> packageObj.config.id == term.package_id)
    let characterObj = packageObj.characters.find((character)=> character.id == term.character_id)
    let traitObj = characterObj.trait_ids[term.trait_index]
    traitObj._destroy = true
    state.isChange = true
  },
  removeTempTrait: (state, term) => {
    let packageObj = state.packages.find((packageObj)=> packageObj.config.id == term.package_id)
    let characterObj = packageObj.characters.find((character)=> character.id == term.character_id)
    characterObj.tempTrait = {id: '', value: ''}
  },
  restorePackage: (state, term) => {
    let package_type = term.report_type.charAt(term.report_type.length - 1)
    state.packages[package_type].characters = term.stats.characters
    state.packages[package_type].characters.forEach(character => {
      character['tempTrait'] = {name: '', value: ''}
    });
  },
  resetState: (state)=>{
    Object.assign(state, getDefaultState())
  },
  createPackage: (state, term) => {
    const packageObj = state.packages.find((packageObj)=> packageObj.config.id == term.package.id)
    if (packageObj){
      return
    }else{
      const tempTraits = [];
      // console.log("🚀 ~ term.assign_traits:", term.assign_traits)
      term.assign_traits.forEach(responseItem => {
        const traitId = responseItem.attributes.trait_id;
        const score = responseItem.attributes.score;
        const report_metum_id = responseItem.id;
        // Find matching template character
        // from api response of report meta
        const matchingCharacter = term.package.characters.find(character => {
          return character.traits.find(trait => trait.id == traitId)
        });
        // console.log("🚀 ~ matchingCharacter ~ matchingCharacter:", matchingCharacter)

        // If matching character found, add it to the characters array
        if (matchingCharacter) {
          let tempChar = tempTraits.find(item => item.id == matchingCharacter.id)
          // check if character already exist
          if (tempChar){
            tempChar.trait_ids.push({id: traitId, value: score, report_metum_id })
          }else{
            tempTraits.push({
              id: matchingCharacter.id,
              trait_ids: [{id: traitId, value: score, report_metum_id }],
            });
          }
        }
      });
      
      let characters = term.package.characters.map((character)=>{
        let assign_character = tempTraits.find(item => item.id == character.id)
        // console.log("🚀 ~ file: statistic.js:121 ~ characters ~ assign_character:", assign_character)
        return {
          id: character.id,
          trait_ids: assign_character?.trait_ids || [],
          tempTrait: {id:'', value: ''}
        }
      })
      
      state.packages.push({
        config: term.package,
        characters
      })
    }
  }

};

const actions = {
  updateReports: (context, term)=>{
    context.commit('updateReports', term);
  },
  updateReport: (context, term)=>{
    context.commit('updateReport', term);
  },
  addNew: (context, term) => {
    context.commit('addNew', term);
  },
  updateTrait: (context, term)=>{
    context.commit('updateTrait', term);
  },
  removeTrait: (context, term)=>{
    context.commit('removeTrait', term);
  },
  removeTempTrait: (context, term)=>{
    context.commit('removeTempTrait', term);
  },
  restorePackage: (context, term)=>{
    context.commit('restorePackage', term);
  },
  resetState: (context)=>{
    context.commit('resetState');
  },
  createPackage: (context, term)=>{
    context.commit('createPackage', term);
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};